import axios from "axios";
import React, { useState } from "react";
import "./product.css";
import "./Object.css";

export const Product = () => {
  const [item, setItem] = useState([]);

  useState(() => {
    axios.get("/api/innovation/getlast").then((res) => {
      setItem(res.data);
    });
  });

  return (
    <div>
      <section className="py-5">
        <div className="container incontainer my-5">
          <div className="row gx-5 justify-content-center">
            <div className="col-lg-8 col-xl-6">
              <div className="text-center ino-box">
                <h2 className="fw-bolder text-white" style={{ textShadow: "0 2px 4px rgba(0,0,0,0.5)" }}>Innovation</h2>
              </div>
            </div>
          </div>
          <div className="row gx-1 mx-0 px-0 row-cols-1">
            {item.map((datas) => {
              return (
                <div className="row gx-4 innov-block mb-4" key={datas._id}>
                  <div className="col-lg-12 mb-5 mx-3">
                    <div className="premium-card px-4 py-3">
                      <div className="row align-items-center">
                        <div className="col-md-8 mb-3 card-body text-justify p-4">
                          <a
                            className="text-decoration-none link-light stretched-link"
                            href={`/innovationdetails/${datas._id}`}
                          >
                            <h4 className="card-title my-3 mb-3 fw-bolder text-white">
                              {datas.name}
                            </h4>
                          </a>
                          <p className="card-text mb-0 c-text-align text-white mt-3" style={{ opacity: 0.9 }}>
                            {datas.desc}
                          </p>
                        </div>
                        <div className="col-md-4 p-4 text-center align-self-center">
                          <img
                            src={"/upload/" + datas.image}
                            alt="..."
                            className="img-fluid rounded  mx-auto"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};
